import { Action } from 'redux';

import { EncryptContent } from '../../../bootstrap/redux/actions/AppActionTypes';
import { isActionFactory } from '../../../bootstrap/redux/actions/isActionFactory';
import { IContentInfo } from '../../../spacesPlatform/models/IContentInfo';

export enum EncryptionActionType {
  encryptExtracts = 'encryptExtracts',
  decryptExtracts = 'decryptExtracts'
}

export interface EncryptContentAction extends Action {
  contentArray: IContentInfo[];
  encryptionActionType: EncryptionActionType;
}

export function encryptContent(contentArray: IContentInfo[], encryptionActionType: EncryptionActionType): EncryptContentAction {
  return {
    type: EncryptContent,
    contentArray: contentArray,
    encryptionActionType: encryptionActionType
  };
}

export const isEncryptContentAction = isActionFactory<EncryptContentAction>(EncryptContent);
